import { Card, Switch, Typography } from 'antd'
import _ from 'lodash'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { useAsync } from 'react-use'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function Setup({ value = [], onChange }) {
  const { t } = useTranslate()

  const filterMenus = useStoreState((state) => state.filter.menus)

  const getFilterMenus = useStoreActions((actions) => actions.filter.getMenus)

  useAsync(async () => {
    getFilterMenus()
  }, [])

  const dataSource = _.map(filterMenus, (filterMenu) => {
    return {
      id: filterMenu?.id,
      name: filterMenu?.name,
    }
  })

  return (
    <Styled className="setup-component">
      <Card size="small">
        <div className="setup-table">
          <ul>
            <li className="head">
              <div className="head-block">
                <div className="module">
                  <Typography.Text>{t('Module')}</Typography.Text>
                </div>
                <div className="setup">
                  <Typography.Text>{t('Setup')}</Typography.Text>
                </div>
              </div>
            </li>
            {_.map(dataSource, (data, index) => {
              const isActive = _.includes(value, data.id)
              return (
                <li key={index} className="item">
                  <div className="item-block">
                    <div className="module-block">
                      <div className="module-name">
                        <Typography.Text>{data.name}</Typography.Text>
                      </div>
                      <div className="setup-check">
                        <Switch
                          checked={isActive}
                          size="small"
                          onChange={(checked) => {
                            if (checked) {
                              onChange([...value, data.id])
                            } else {
                              onChange(_.filter(value, (v) => v !== data.id))
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </Card>
    </Styled>
  )
}
